import React, { useState } from 'react';
import ListLayout from 'components/ListLayout';
import styled from 'styled-components';
import DateRange from './DateRange';
import SummaryTable from './SummaryTable/SummaryTable';
import ListOrder from './ListOrderTable/ListOrder';
import { useQuery } from 'react-query';
import { format, isBefore } from 'date-fns';
import Loader from 'components/Loader';
import ListOrderTable from './ListOrderTable/ListOrderTable';
import { periodWeekly } from 'utils';
import { revenuesApiV2 } from 'services/revenuesService';
import { debounce } from 'lodash';

const PaymentRevenuesWrapper = styled.div`
  margin: 0;
`;

const PaymentRevenues = () => {
  const [startAndEndDate, setStartAndEndDate] = useState(periodWeekly);
  const [isOpenPanelRight, setIsOpenPanelRight] = useState(false);
  const [invoiceId, setInvoiceId] = useState<number | undefined>(undefined);

  const startDate = format(startAndEndDate[0], 'yyyy-MM-dd');
  const endDate = format(startAndEndDate[1], 'yyyy-MM-dd');

  const { isLoading, data, isFetching } = useQuery(
    ['getListOrder', startDate, endDate],
    ({ signal }) => revenuesApiV2({ startDate, endDate, signal })
  );

  const onStartAndEndDateChange = debounce((date: Date[]) => {
    if (isBefore(date[1], date[0])) {
      return;
    }

    setStartAndEndDate([date[0], date[1]]);
  }, 450);

  return (
    <ListLayout>
      <PaymentRevenuesWrapper>
        <DateRange onData={onStartAndEndDateChange} />
        <SummaryTable onData={data!} />
        <ListOrder
          isOpenPanelRight={setIsOpenPanelRight}
          passId={(id) => setInvoiceId(id)}
          onData={data}
        />
        {isOpenPanelRight && invoiceId && (
          <ListOrderTable
            isClosePanelRight={setIsOpenPanelRight}
            id={invoiceId}
            onData={data!}
          />
        )}
      </PaymentRevenuesWrapper>
      {isLoading || isFetching ? <Loader /> : null}
    </ListLayout>
  );
};

export default PaymentRevenues;
